import { useEffect, useState } from 'react';
import { Button } from '../Button/Button';
import './_AnchorLink.scss';

const ArrowUp = () => <i className='arrow-up' />;

export const AnchorLink = () => {
  const [showLink, setShowLink] = useState(false);

  const handleScroll = () => {
    const bottom = Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight;

    if (bottom) {
      setShowLink(true);
    } else {
      setShowLink(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, true);

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  const goToTop = () => {
    document.querySelector('body').scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      { showLink && (
      <Button
        circular
        text={<ArrowUp />}
        onClick={goToTop}
      />
      ) }
    </>
  );
};
